import { z } from 'zod'

const envSchema = z.object({
  NEXT_PUBLIC_WEB_BUYING_FLOW_DOMAIN: z.string(),
  NEXT_PUBLIC_DOMAIN: z.string(),
  NEXT_PUBLIC_APP_ENV: z.enum(['development', 'production', 'staging', 'testing']),
  NEXT_PUBLIC_SANITY_API_VERSION: z.string(),
  NEXT_PUBLIC_SANITY_PROJECT_ID: z.string(),
  NEXT_PUBLIC_SANITY_DATASET: z.string(),
  NEXT_PUBLIC_SEGMENT_IO_ID: z.string(),
  NEXT_PUBLIC_COOKIE_FIRST_KEY: z.string().optional(),
  NEXT_PUBLIC_SPLIT_IO_SERVER_API_KEY: z.string(),
  NEXT_PUBLIC_GETSAFE_TYPEFORM_DOMAIN: z.string(),
  NEXT_PUBLIC_USER_SERVICE: z.string(),
  NEXT_PUBLIC_PERSONALIZATION_SERVICE: z.string(),
  NEXT_PUBLIC_OPERATIONS_SERVICE: z.string(),
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: z.string(),
  NEXT_PUBLIC_RUM_APPLICATION_ID: z.string(),
  NEXT_PUBLIC_RUM_SERVICE_NAME: z.string(),
})

const envSchemaServer = envSchema.merge(
  z.object({
    AIR_TABLE_BASE: z.string(),
    // TODO: https://hellogetsafe.atlassian.net/browse/HAPPY-115
    // Address Airtable token deprecation
    AIR_TABLE_TOKEN: z.string(),
    LTV_PRICING_SERVICE: z.string(),
  })
)

// We need to manually reference the variables, otherwise Next.js strips them
// from the client at build time.
const envVariables = {
  NEXT_PUBLIC_WEB_BUYING_FLOW_DOMAIN: process.env.NEXT_PUBLIC_WEB_BUYING_FLOW_DOMAIN,
  NEXT_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  NEXT_PUBLIC_SANITY_API_VERSION: process.env.NEXT_PUBLIC_SANITY_API_VERSION,
  NEXT_PUBLIC_SANITY_PROJECT_ID: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  NEXT_PUBLIC_SANITY_DATASET: process.env.NEXT_PUBLIC_SANITY_DATASET,
  AIR_TABLE_BASE: process.env.AIR_TABLE_BASE,
  AIR_TABLE_TOKEN: process.env.AIR_TABLE_TOKEN,
  NEXT_PUBLIC_SEGMENT_IO_ID: process.env.NEXT_PUBLIC_SEGMENT_IO_ID,
  NEXT_PUBLIC_COOKIE_FIRST_KEY: process.env.NEXT_PUBLIC_COOKIE_FIRST_KEY,
  NEXT_PUBLIC_SPLIT_IO_SERVER_API_KEY: process.env.NEXT_PUBLIC_SPLIT_IO_SERVER_API_KEY,
  NEXT_PUBLIC_GETSAFE_TYPEFORM_DOMAIN: process.env.NEXT_PUBLIC_GETSAFE_TYPEFORM_DOMAIN,
  NEXT_PUBLIC_USER_SERVICE: process.env.NEXT_PUBLIC_USER_SERVICE,
  NEXT_PUBLIC_PERSONALIZATION_SERVICE: process.env.NEXT_PUBLIC_PERSONALIZATION_SERVICE,
  NEXT_PUBLIC_OPERATIONS_SERVICE: process.env.NEXT_PUBLIC_OPERATIONS_SERVICE,
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  NEXT_PUBLIC_RUM_APPLICATION_ID: process.env.NEXT_PUBLIC_RUM_APPLICATION_ID,
  NEXT_PUBLIC_RUM_SERVICE_NAME: process.env.NEXT_PUBLIC_RUM_SERVICE_NAME,
  LTV_PRICING_SERVICE: process.env.LTV_PRICING_SERVICE,
}

export const {
  NEXT_PUBLIC_WEB_BUYING_FLOW_DOMAIN: WEB_BUYING_FLOW_DOMAIN,
  NEXT_PUBLIC_DOMAIN: DOMAIN,
  NEXT_PUBLIC_APP_ENV: APP_ENV,
  NEXT_PUBLIC_SANITY_API_VERSION: SANITY_API_VERSION,
  NEXT_PUBLIC_SANITY_PROJECT_ID: SANITY_PROJECT_ID,
  NEXT_PUBLIC_SANITY_DATASET: SANITY_DATASET,
  NEXT_PUBLIC_COOKIE_FIRST_KEY: COOKIE_FIRST_KEY,
  NEXT_PUBLIC_SEGMENT_IO_ID: SEGMENT_IO_ID,
  NEXT_PUBLIC_SPLIT_IO_SERVER_API_KEY: SPLIT_IO_SERVER_API_KEY,
  NEXT_PUBLIC_GETSAFE_TYPEFORM_DOMAIN: GETSAFE_TYPEFORM_DOMAIN,
  NEXT_PUBLIC_USER_SERVICE: USER_SERVICE,
  NEXT_PUBLIC_PERSONALIZATION_SERVICE: PERSONALIZATION_SERVICE,
  NEXT_PUBLIC_OPERATIONS_SERVICE: OPERATIONS_SERVICE,
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: DATADOG_CLIENT_TOKEN,
  NEXT_PUBLIC_RUM_APPLICATION_ID: RUM_APPLICATION_ID,
  NEXT_PUBLIC_RUM_SERVICE_NAME: RUM_SERVICE_NAME,
} = envSchema.parse(envVariables)

export const TRACK_URL = `${APP_ENV !== 'development' ? 'https://' : 'http://'}${DOMAIN}/api/track`

export const PLAUSIBLE_EVENT_TRACK_URL = 'https://plausible.io/api/event'

export const getServerEnv = () => {
  return envSchemaServer.parse(envVariables)
}

export const isDev = () => APP_ENV === 'development'

export const PLAUSIBLE_DOMAINS =
  APP_ENV === 'production'
    ? 'hellogetsafe.com,hellogetsafe.com.combined'
    : 'gtsf.insure,gtsf.insure.combined'
